/**
 * @generated SignedSource<<695644bd80b5b3a1c34ab780f9bee7bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthShareModal_user">;
  readonly " $fragmentType": "PdpSharedSendToFriendModalLazy_user";
};
export type PdpSharedSendToFriendModalLazy_user$key = {
  readonly " $data"?: PdpSharedSendToFriendModalLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthShareModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e3f5c435a70cdcebc02692e7118c25b6";

export default node;
